export function OnlineBadge({ online }: { online: boolean }) {
  return (
    <span className={`online-badge mono ${online ? 'online-badge--on' : 'online-badge--off'}`}>
      <span className={`status-dot ${online ? 'status-dot--available' : 'status-dot--locked'}`} />
      {online ? 'מחובר' : 'מצב לא מקוון'}
    </span>
  );
}
